<template>
    <div class="__l">
        <div class="flex justify-between mb-8 items-center">
            <div>
                <h1 class="text-4xl tracking-widest uppercase font-bold text-gray-700">Events</h1>
            </div>
            <div>
                <button class="btn-primary" type="button" @click="createEventDate">Create Event</button>
            </div>
        </div>
        <input type="text" v-model="search" class="form-field py-4 px-6" ref="searchbar" placeholder="Search for Events"
               @keyup.enter="handleSearch">
        <div v-if="results.data" class="my-2 text-center">
            <p>The total number of results for <strong>"{{ search }}"</strong> is <strong>{{ results.total }}</strong>
            </p>
        </div>
        <div class="results-list">
            <div class="results-row">
                <div class="results-head" data-width="10%">ID</div>
                <div class="results-head" data-width="50%">Title</div>
                <div class="results-head" data-width="20%">Submitted</div>
                <div class="results-head" data-width="20%">Published</div>
            </div>
            <template v-if="results.data">
                <div class="results-row" v-for="(result, index) in results.data" :key="index"
                     @click="handleSelectedEvent(result)">
                    <div class="results-cell" data-width="10%">{{ result.id }}</div>
                    <div class="results-cell" data-width="50%">{{ result.title }}</div>
                    <div class="results-cell" data-width="20%">{{ formatDateShort(result.created_at) }}</div>
                    <div class="results-cell table-cell" data-width="20%">
                        <button class="table-button active" v-if="result.published">Published</button>
                        <button class="table-button inactive" v-else>Inactive</button>
                    </div>
                </div>
                <pagination v-model="page" :records="results.total" :per-page="25"
                            @paginate="loadData"></pagination>
            </template>
            <div class="results-row" v-if="!results.data">
                <div class="results-span text-center" data-width="100%">
                    <p>No results found</p>
                </div>
            </div>
        </div>
        <router-view v-slot="{ Component }">
            <transition name="drop-in" mode="in-out">
                <component :is="Component"></component>
            </transition>
        </router-view>
    </div>
</template>

<script>
import Pagination from 'v-pagination-3'
import {useStore} from "vuex"

export default {
    name: 'EventList',
    props: {
        //
    },
    data() {
        return {
            search: null,
            results: {},
            page: 1,
        }
    },
    components: {
        Pagination,
    },
    computed: {
        sectors () {
            const store = useStore()
            return store.state.sectors ?? []
        },
        locations () {
            const store = useStore()
            return store.state.locations ?? []
        },
    },
    mounted() {
        window.setTimeout(function () {
            this.$refs.searchbar.focus()
        }.bind(this), 100)

        this.setMetaTitle('List Events | JournoLink Control')
    },
    methods: {
        handleSearch() {
            this.loadData()
        },
        /**
         * Load the results from the data provider
         *
         * @return {void}
         */
        loadData() {
            axios.get(route('event.list'), {
                params: {
                    term: this.search,
                    page: this.page,
                },
            })
                .then(response => {
                    this.results = response.data.results
                })
                .catch(e => {
                    console.error({e})
                })
        },
        /**
         * create Event
         * @return {void}
         */
        createEventDate() {
            this.$router.push({name: 'event.create'})
        },
        /**
         * Handle the selection of a Event
         *
         * @param  {Object} calendar
         * @return {void}
         */
        handleSelectedEvent(event) {
            this.$router.push({name: 'event.show', params: {eventId: event.id}})
        },
    },
    beforeRouteUpdate(to, from, next) {
        if (to && to.name === 'event.list') {
            this.setMetaTitle('List Events | JournoLink Control')
            this.loadData()
        }

        if (to && to.params.newEvent) {
            window.setTimeout(() => {
                this.$router.push({name: 'event.show', params: {eventId: to.params.newEvent.id}})
            }, 500)

            next()
        }

        next()
    },
}
</script>

<style lang="less">
.table-cell {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    .table-button {
        padding: 5px;
        border-radius: 3px;
        color: white;
        background-color: #2980b9;
        width: 80px;
    }

    .requires-approval, .inactive {
        background-color: #2c3e50;
    }

    .approved, .requires-approval {
        width: 140px;
    }
}
</style>
